import { httpClient, HttpMethod } from './http-client';
import { RegionType } from '../@types/regionType.type';

export const getRegionTypes = (): Promise<RegionType[]> => {
  return httpClient<RegionType[]>('/regiontypes', HttpMethod.Get);
};
